'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { assert, cn } from '@core/utils';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { UnauthInfiniteQueryOptions } from '@/api';
import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useScrollTop } from '@/hooks/useScrollTop';
import { INITIAL_PAGE, INITIAL_SIZE, PRODUCTS_PER_BLOCK, REVIEWS_PER_BLOCK } from '../../constants';
import type { GiftProductSortType, InstitutionOption, SortOption } from '../../types';
interface ContentsProps {
  institutionOptions: InstitutionOption[];
  sortOptions: SortOption[];
  sort?: GiftProductSortType;
  institutionId?: number;
  categoryId?: number;
  isStockOnly?: boolean;
}
export const Contents = t0 => {
  const $ = _c(60);
  const {
    institutionOptions,
    sortOptions,
    sort,
    institutionId,
    categoryId,
    isStockOnly
  } = t0;
  useScrollTop();
  const router = useCustomRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      rootMargin: "600px 0px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref,
    inView
  } = useInView(t1);
  const productsPerBlock = PRODUCTS_PER_BLOCK.DESKTOP;
  const reviewsPerBlock = REVIEWS_PER_BLOCK.DESKTOP;
  let t2;
  if ($[1] !== categoryId || $[2] !== institutionId || $[3] !== isStockOnly || $[4] !== sort) {
    t2 = UnauthInfiniteQueryOptions["get:/wello/v2/allows/home/gift-product/block"]({
      query: {
        categoryId,
        institutionId,
        stockOnlyYN: isStockOnly,
        giftProductSortType: sort,
        page: INITIAL_PAGE,
        blockSize: INITIAL_SIZE,
        productsPerBlock: productsPerBlock.count,
        reviewsPerBlock: reviewsPerBlock.count
      }
    });
    $[1] = categoryId;
    $[2] = institutionId;
    $[3] = isStockOnly;
    $[4] = sort;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      ...t2,
      getNextPageParam: _temp,
      initialPageParam: INITIAL_PAGE
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: gifts,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isLoading
  } = useInfiniteQuery(t3);
  let t4;
  let t5;
  if ($[8] !== fetchNextPage || $[9] !== hasNextPage || $[10] !== inView || $[11] !== isFetching) {
    t4 = () => {
      if (!isFetching && inView && hasNextPage) {
        fetchNextPage();
      }
    };
    t5 = [inView, isFetching, fetchNextPage, hasNextPage];
    $[8] = fetchNextPage;
    $[9] = hasNextPage;
    $[10] = inView;
    $[11] = isFetching;
    $[12] = t4;
    $[13] = t5;
  } else {
    t4 = $[12];
    t5 = $[13];
  }
  useEffect(t4, t5);
  let t6;
  if ($[14] !== router) {
    t6 = value => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("sort", value);
      router.replace(DONATION_ROUTES.GIFTS.withSearchParams({
        searchParams: Object.fromEntries(searchParams)
      }));
    };
    $[14] = router;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const handleSortChange = t6;
  let t7;
  if ($[16] !== router) {
    t7 = value_0 => {
      const searchParams_0 = new URLSearchParams(location.search);
      searchParams_0.set("institutionId", String(value_0));
      if (value_0 === 0) {
        searchParams_0.delete("institutionId");
      }
      router.replace(DONATION_ROUTES.GIFTS.withSearchParams({
        searchParams: Object.fromEntries(searchParams_0)
      }));
    };
    $[16] = router;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const handleInstitutionChange = t7;
  const isEmpty = !isLoading && (gifts?.pages?.[0]?.context?.totalCount ?? 0) < 1;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex flex-1 flex-col gap-16 pt-34", "mobile-tablet:pt-16");
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cn("font-500 text-Gray-black typo-body3", "mobile-tablet:typo-body4");
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== gifts?.pages?.[0]?.context?.totalCount) {
    t10 = gifts?.pages?.[0]?.context?.totalCount?.toLocaleString() ?? 0;
    $[20] = gifts?.pages?.[0]?.context?.totalCount;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <p className={t9}>전체 {t10}개</p>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== handleSortChange) {
    t12 = value_1 => {
      handleSortChange(value_1);
    };
    $[24] = handleSortChange;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== sort || $[27] !== sortOptions || $[28] !== t12) {
    t13 = <DropdownMenu options={sortOptions} value={sort} onChange={t12} type="text" placeholder={"\uC815\uB82C \uAE30\uC900 \uC120\uD0DD"} />;
    $[26] = sort;
    $[27] = sortOptions;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== handleInstitutionChange) {
    t14 = value_2 => {
      handleInstitutionChange(value_2);
    };
    $[30] = handleInstitutionChange;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== institutionId || $[33] !== institutionOptions || $[34] !== t14) {
    t15 = <DropdownMenu options={institutionOptions} value={institutionId} onChange={t14} type="text" placeholder={"\uC9C0\uC790\uCCB4 \uC120\uD0DD"} className="hidden mobile-tablet:block" />;
    $[32] = institutionId;
    $[33] = institutionOptions;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t13 || $[37] !== t15) {
    t16 = <div className="flex items-center gap-8">{t13}{t15}</div>;
    $[36] = t13;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t11 || $[40] !== t16) {
    t17 = <header className="flex items-center justify-between">{t11}{t16}</header>;
    $[39] = t11;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== isLoading) {
    t18 = isLoading ? <ul className={cn("grid gap-x-20 gap-y-48", "grid-cols-4 mobile:grid-cols-2 tablet:grid-cols-3")}>{Array.from({
        length: productsPerBlock.count
      }).map(_temp2)}</ul> : null;
    $[42] = isLoading;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== gifts?.pages) {
    t19 = gifts?.pages ? <div className="flex flex-col gap-48">{gifts?.pages?.flatMap(_temp3)?.map(_temp5)}</div> : null;
    $[44] = gifts?.pages;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== isFetchingNextPage) {
    t20 = isFetchingNextPage ? <ul className={cn("grid gap-x-20 gap-y-48", "grid-cols-4 mobile:grid-cols-2 tablet:grid-cols-3")}>{Array.from({
        length: productsPerBlock.count
      }).map(_temp6)}</ul> : null;
    $[46] = isFetchingNextPage;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== hasNextPage || $[49] !== ref) {
    t21 = hasNextPage ? <div ref={ref} className="h-1 w-full" /> : <></>;
    $[48] = hasNextPage;
    $[49] = ref;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== isEmpty) {
    t22 = isEmpty ? <section className="py-160 flex-center"><p className="text-center font-400 text-Gray-550 typo-body3">아직 등록된 답례품이 없어요.<br />준비 중이니 조금만 기다려주세요.</p></section> : <></>;
    $[51] = isEmpty;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t17 || $[54] !== t18 || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22) {
    t23 = <section className={t8}>{t17}{t18}{t19}{t20}{t21}{t22}</section>;
    $[53] = t17;
    $[54] = t18;
    $[55] = t19;
    $[56] = t20;
    $[57] = t21;
    $[58] = t22;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  return t23;
};
function _temp(lastPage) {
  assert(lastPage.context);
  const {
    hasNext: has_next,
    page
  } = lastPage.context;
  if (has_next) {
    return page + 1;
  }
}
function _temp2(_, index) {
  return <GiftListItem isLoading={true} key={index} />;
}
function _temp3(page_0) {
  return page_0.context?.blocks ?? [];
}
function _temp4(t0) {
  const {
    productNumber: product_number,
    productSlugId,
    mainImageUrl: main_image_url,
    productName: product_name,
    requiredDonationAmount: required_donation_amount,
    reviewCount: review_count,
    reviewRating: review_rating,
    institutionId: institution_id,
    institutionSlugId,
    institutionLogoUrl: institution_logo_url,
    institutionName: institution_name,
    newDisplayYN: new_display_yn,
    adultYN: adult_yn,
    productSaleStatus: product_sale_status
  } = t0;
  return <GiftListItem key={product_number} mainImageSizes={`${BREAKPOINTS.MOBILE} 50vw, ${BREAKPOINTS.TABLET} 33vw, 240px`} mainImageUrl={main_image_url} productName={product_name} donationAmount={required_donation_amount} reviewCount={review_count} reviewRating={review_rating} institution={{
    id: institutionSlugId ?? institution_id,
    logoUrl: institution_logo_url,
    name: institution_name
  }} productNumber={productSlugId ?? product_number} isNew={new_display_yn} isAdult={adult_yn} isSoldOut={product_sale_status === GIFT_SALE_STATUS.SOLD_OUT} responsiveClassName={{
    institutionLogo: "mobile-tablet:size-20",
    institutionName: "mobile-tablet:typo-caption1 mobile-tablet:font-600",
    productName: "mobile-tablet:typo-body4 mobile-tablet:font-500",
    donationAmount: "mobile-tablet:typo-body3 mobile-tablet:font-700",
    donationAmountText: "mobile-tablet:typo-body4 mobile-tablet:font-600"
  }} />;
}
function _temp5(t0, index_0) {
  const {
    products
  } = t0;
  return <section className="flex flex-col gap-48" key={index_0}><ul className={cn("grid gap-x-20 gap-y-48", "grid-cols-4 mobile:grid-cols-2 tablet:grid-cols-3")} key={index_0}>{products.map(_temp4)}</ul></section>;
}
function _temp6(__0, index_1) {
  return <GiftListItem isLoading={true} key={index_1} />;
}